export default __webpack_public_path__ + "static/media/landingImage.193be6d9.webp";